<div class="site-selection-dropdown-field" cdkOverlayOrigin #dropdownOrigin="cdkOverlayOrigin"
  [ngClass]="dropdownConfig().customClass">
  <!-- Closed trigger -->
  <mat-form-field appearance="fill" class="select-dropdown-field-regular notranslate"
    [class.select-dropdown-field-open]="isOpen()"
    (click)="toggleDropdown()">
    <input #triggerInput matInput class="notranslate" [placeholder]="dropdownConfig().placeholder"
      [value]="triggerLabel()" [disabled]="isDisabledMode()" readonly />
    <button type="button" matSuffix mat-icon-button aria-label="Toggle dropdown" [disabled]="isDisabledMode()"
      (click)="$event.stopPropagation(); toggleDropdown()">
      <i class="fas select-dropdown-field-arrow" [ngClass]="isOpen() ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
    </button>
  </mat-form-field>

  <!-- Dropdown overlay -->
  <ng-template cdkConnectedOverlay [cdkConnectedOverlayOpen]="isOpen()" [cdkConnectedOverlayOrigin]="dropdownOrigin"
    [cdkConnectedOverlayHasBackdrop]="true" [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
    [cdkConnectedOverlayPanelClass]="['site-selection-dropdown-panel', dropdownConfig().panelClass]"
    [cdkConnectedOverlayOffsetY]="4" [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
    (backdropClick)="onBackdropClick()" (attach)="onOverlayAttached()">
    <div #panelSurface class="site-selection-dropdown-panel-surface" [style.max-height.px]="overlayHeight()" tabindex="0" (keydown)="onDropdownKeydown($event)">
      <!-- Search, view, and sort controls -->
      <div class="search-filters-container">
        <mat-form-field appearance="fill" class="app-mat-form-search-field site-selection-search hide-mat-error-field"
          id="dropDownSearch"
          [ngClass]="{'site-selection-search-without-group' : !dropdownConfig().enableChangeViewButton}">
          <i class="fas fa-search search-icon" matPrefix></i>
          <input #searchInput matInput class="notranslate medium-text" [value]="searchTerm()"
            (input)="onSearchInput($any($event.target).value)" [placeholder]="dropdownConfig().searchPlaceholder"
            autocomplete="off" id="dropdown-search-field" />

          @if (searchTerm()) {
          <i class="fas fa-times" (click)="clearSearch(); $event.stopPropagation();" matSuffix id="close-search"></i>
          }
        </mat-form-field>

        <div class="filter-icons-container">
          <button type="button" mat-icon-button class="view-mode-icon icon-style" (click)="changeView()"
            [matTooltip]="viewMode() === 'list' ? 'List view' : 'Group View'" matTooltipPosition="above"
            [matTooltipClass]="'app-mat-tooltip-text'" *ngIf="dropdownConfig().enableChangeViewButton">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"
              *ngIf="viewMode() === 'list'">
              <path
                d="M13.0157 10.2307C13.2162 10.2307 13.4168 10.4327 13.4168 10.6346V11.4423C13.4168 11.6694 13.2162 11.8461 13.0157 11.8461H0.982096C0.75651 11.8461 0.581055 11.6694 0.581055 11.4423V10.6346C0.581055 10.4327 0.75651 10.2307 0.982096 10.2307H13.0157ZM13.0157 2.15381C13.2162 2.15381 13.4168 2.35573 13.4168 2.55765V3.36535C13.4168 3.59251 13.2162 3.76919 13.0157 3.76919H0.982096C0.75651 3.76919 0.581055 3.59251 0.581055 3.36535V2.55765C0.581055 2.35573 0.75651 2.15381 0.982096 2.15381L13.0157 2.15381ZM13.0157 6.19227C13.2162 6.19227 13.4168 6.39419 13.4168 6.59612V7.40381C13.4168 7.63097 13.2162 7.80765 13.0157 7.80765H0.982096C0.75651 7.80765 0.581055 7.63097 0.581055 7.40381V6.59612C0.581055 6.39419 0.75651 6.19227 0.982096 6.19227H13.0157Z"
                fill="currentColor" />
            </svg>

            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"
              *ngIf="viewMode() === 'group'">
              <path
                d="M13.0157 10.2308C13.2162 10.2308 13.4168 10.4327 13.4168 10.6346V11.4423C13.4168 11.6695 13.2162 11.8461 13.0157 11.8461H3.89876C3.67318 11.8461 3.49772 11.6695 3.49772 11.4423V10.6346C3.49772 10.4327 3.67318 10.2308 3.89876 10.2308H13.0157ZM13.0157 2.15384C13.2162 2.15384 13.4168 2.35576 13.4168 2.55769V3.36538C13.4168 3.59254 13.2162 3.76922 13.0157 3.76922H0.982096C0.75651 3.76922 0.581055 3.59254 0.581055 3.36538V2.55769C0.581055 2.35576 0.75651 2.15384 0.982096 2.15384L13.0157 2.15384ZM13.0157 6.1923C13.2162 6.1923 13.4168 6.39422 13.4168 6.59615V7.40384C13.4168 7.631 13.2162 7.80769 13.0157 7.80769H3.89876C3.67318 7.80769 3.49772 7.631 3.49772 7.40384V6.59615C3.49772 6.39422 3.67318 6.1923 3.89876 6.1923H13.0157Z"
                fill="currentColor" />
            </svg>
          </button>

          <button type="button" mat-icon-button class="filter-icon icon-style"
            [class.filter-icon-open]="isSortMenuOpen()" [matMenuTriggerFor]="sortMenu"
            (click)="$event.stopPropagation()" (menuOpened)="onSortMenuOpened()" (menuClosed)="onSortMenuClosed()"
            [matTooltip]="sortTooltipLabel()" matTooltipPosition="above" [matTooltipClass]="'app-mat-tooltip-text'">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M8.31996 11.1667C8.53842 11.1667 8.75689 11.3751 8.75689 11.5834V12.4167C8.75689 12.6511 8.53842 12.8334 8.31996 12.8334H6.57226C6.32649 12.8334 6.13533 12.6511 6.13533 12.4167V11.5834C6.13533 11.3751 6.32649 11.1667 6.57226 11.1667H8.31996ZM4.82455 9.50008C5.20686 9.50008 5.39802 9.96883 5.12494 10.2292L2.94031 12.7292C2.85839 12.8074 2.74915 12.8334 2.63992 12.8334C2.50338 12.8334 2.39415 12.8074 2.31223 12.7292L0.127599 10.2292C-0.14548 9.96883 0.0456753 9.50008 0.455293 9.50008H1.76607V1.58341C1.76607 1.37508 1.95723 1.16675 2.203 1.16675H3.07685C3.29531 1.16675 3.51378 1.37508 3.51378 1.58341V9.50008H4.82455ZM11.8154 4.50008C12.0338 4.50008 12.2523 4.70841 12.2523 4.91675V5.75008C12.2523 5.98446 12.0338 6.16675 11.8154 6.16675H6.57226C6.32649 6.16675 6.13533 5.98446 6.13533 5.75008V4.91675C6.13533 4.70841 6.32649 4.50008 6.57226 4.50008H11.8154ZM10.0677 7.83342C10.2861 7.83342 10.5046 8.04175 10.5046 8.25008V9.08342C10.5046 9.31779 10.2861 9.50008 10.0677 9.50008H6.57226C6.32649 9.50008 6.13533 9.31779 6.13533 9.08342V8.25008C6.13533 8.04175 6.32649 7.83342 6.57226 7.83342H10.0677ZM13.5631 1.16675C13.7815 1.16675 14 1.37508 14 1.58341V2.41675C14 2.65112 13.7815 2.83341 13.5631 2.83341H6.57226C6.32649 2.83341 6.13533 2.65112 6.13533 2.41675V1.58341C6.13533 1.37508 6.32649 1.16675 6.57226 1.16675H13.5631Z"
                fill="currentColor" />
            </svg>
          </button>
        </div>
      </div>

      @if (itemsLoading() && !items().length) {
      <div class="site-selection-dropdown-loader-container">
        <ngx-skeleton-loader [theme]="{height: '28px'}" [count]="8"></ngx-skeleton-loader>
      </div>
      } @else if (!filteredItems().length) {
      <div class="site-selection-dropdown-empty medium-text p-r-8">{{ noResultsLabel() }}</div>
      @if (dropdownConfig().remoteFilter && selectedItemsFromCache().length) {
      <div class="site-selection-dropdown-option remote-filter-option-selected notranslate">
        <ng-container *ngTemplateOutlet="singleSelectOptionTpl; context: { item: selectedItemsFromCache()[selectedItemsFromCache().length - 1] }"></ng-container>
      </div>
      }
      } @else {
      <!-- Virtual scroll is used for performance optimization when there are many items to display. -->
      <!-- Keep CSS row height in sync with CDK itemSize to prevent blank rows while scrolling fast. -->
      <cdk-virtual-scroll-viewport [itemSize]="dropdownConfig().itemSize" class="site-selection-dropdown-viewport"
        [style.--dropdown-item-size.px]="dropdownConfig().itemSize"
        [style.height.px]="useVirtualScroll() ? viewportHeight() : viewportRows().length * dropdownConfig().itemSize"
        [minBufferPx]="dropdownConfig().itemSize * dropdownConfig().bufferItemsCount"
        [maxBufferPx]="dropdownConfig().itemSize * (dropdownConfig().bufferItemsCount * 2)">
        <!-- Flattened section headers, dividers, and item rows -->
        <div *cdkVirtualFor="let row of viewportRows(); let rowIndex = index; trackBy: trackByRenderedRow"
          class="site-selection-dropdown-virtual-row">
          @if (isSectionHeaderRow(row)) {
          <div class="site-selection-dropdown-section-title small-text-bold"
            *ngIf="!searchTerm() || !searchTerm().trim()">{{ row.label }}</div>
          } @else if (isSectionDividerRow(row)) {
          <div class="site-selection-dropdown-section-divider">
            <span class="site-selection-dropdown-section-divider-line"></span>
          </div>
          } @else if (isSelectAllRow(row)) {
          <div class="site-selection-dropdown-option notranslate" data-site-selection-option
            [class.site-selection-dropdown-option-active]="isActiveSelectAllOption(rowIndex)"
            [attr.data-option-key]="selectAllOptionKey(rowIndex)"
            (click)="onSelectAllOptionSelect()">
            <ng-container *ngTemplateOutlet="multiSelectSelectAllOptionTpl"></ng-container>
          </div>
          } @else if (viewMode() === 'group') {
          @if (isGroupRow(row)) {
          <div class="site-selection-dropdown-group-header site-selection-dropdown-option notranslate"
            [ngClass]="{'small-text-bold no-hover-effect': !dropdownConfig().multiSelect, 'site-selection-dropdown-group-header-multi-select medium-text': dropdownConfig().multiSelect}"
            [class.site-selection-dropdown-option-active]="dropdownConfig().multiSelect && isActiveGroupOption(row, rowIndex)"
            [class.site-selection-dropdown-option-disabled]="isGroupParentDisabled(row)"
            [matTooltip]="dropdownConfig().multiSelect ? getGroupSelectionBlockedTooltip(row) : null" matTooltipPosition="right"
            [matTooltipDisabled]="!(dropdownConfig().multiSelect && getGroupSelectionBlockedTooltip(row))"
            [matTooltipClass]="'app-mat-tooltip-text site-selection-dropdown-option-tooltip'"
            data-site-selection-option
            [attr.data-option-key]="groupOptionKey(row, rowIndex)"
            (click)="dropdownConfig().multiSelect && !isGroupParentDisabled(row) && toggleGroupSelection(row)">
            @if (dropdownConfig().multiSelect) {
            <mat-checkbox class="app-checkbox" tabindex="-1" disableRipple="true" [checked]="isGroupFullySelected(row)"
              [indeterminate]="isGroupPartiallySelected(row) && !isGroupFullySelected(row)"
              [disabled]="isGroupParentDisabled(row)"
              (click)="$event.stopPropagation()" (change)="toggleGroupSelection(row)">
            </mat-checkbox>
            }
            <span>{{ row.label }}</span>
          </div>
          } @else {
          @if (!dropdownConfig().multiSelect) {
          <div class="site-selection-dropdown-option notranslate"
            [class.site-selection-dropdown-option-selected]="selectedItemIds().includes(rawValueOf(row.item))"
            [class.site-selection-dropdown-option-active]="isActiveOption(row.item, rowIndex)"
            [class.site-selection-dropdown-option-disabled]="isItemDisabled(row.item)"
            [matTooltip]="getItemTooltip(row.item)" matTooltipPosition="right"
            [matTooltipDisabled]="!getItemTooltip(row.item)"
            [matTooltipClass]="'app-mat-tooltip-text site-selection-dropdown-option-tooltip'" data-site-selection-option
            [attr.data-option-key]="itemOptionKey(row.item, rowIndex)"
            (click)="onOptionSelect(row.item)">
            <ng-container *ngTemplateOutlet="singleSelectOptionTpl; context: { item: row.item }"></ng-container>
          </div>
          }
          @if (dropdownConfig().multiSelect) {
          <div class="site-selection-dropdown-option notranslate"
            [class.site-selection-dropdown-option-active]="isActiveOption(row.item, rowIndex)"
            [class.site-selection-dropdown-option-disabled]="isItemSelectionBlocked(row.item)"
            [matTooltip]="getSelectionBlockedTooltip(row.item)" matTooltipPosition="right"
            [matTooltipDisabled]="!getSelectionBlockedTooltip(row.item)"
            [matTooltipClass]="'app-mat-tooltip-text site-selection-dropdown-option-tooltip'" data-site-selection-option
            [attr.data-option-key]="itemOptionKey(row.item, rowIndex)"
            (click)="onOptionSelect(row.item)">
            <ng-container *ngTemplateOutlet="multiSelectOptionTpl; context: { item: row.item }"></ng-container>
          </div>
          }
          }
          } @else {
          @if (!dropdownConfig().multiSelect) {
          <div class="site-selection-dropdown-option notranslate"
            [class.site-selection-dropdown-option-selected]="selectedItemIds().includes(rawValueOf(row))"
            [class.site-selection-dropdown-option-active]="isActiveOption(row, rowIndex)"
            [class.site-selection-dropdown-option-disabled]="isItemDisabled(row)" [matTooltip]="getItemTooltip(row)"
            matTooltipPosition="right" [matTooltipDisabled]="!getItemTooltip(row)"
            [matTooltipClass]="'app-mat-tooltip-text site-selection-dropdown-option-tooltip'" data-site-selection-option
            [attr.data-option-key]="itemOptionKey(row, rowIndex)"
            (click)="onOptionSelect(row)">
            <ng-container *ngTemplateOutlet="singleSelectOptionTpl; context: { item: row }"></ng-container>
          </div>
          }
          @if (dropdownConfig().multiSelect) {
          <div class="site-selection-dropdown-option notranslate"
            [class.site-selection-dropdown-option-active]="isActiveOption(row, rowIndex)"
            [class.site-selection-dropdown-option-disabled]="isItemSelectionBlocked(row)" [matTooltip]="getSelectionBlockedTooltip(row)"
            matTooltipPosition="right" [matTooltipDisabled]="!getSelectionBlockedTooltip(row)"
            [matTooltipClass]="'app-mat-tooltip-text site-selection-dropdown-option-tooltip'" data-site-selection-option
            [attr.data-option-key]="itemOptionKey(row, rowIndex)"
            (click)="onOptionSelect(row)">
            <ng-container *ngTemplateOutlet="multiSelectOptionTpl; context: { item: row }"></ng-container>
          </div>
          }
          }
        </div>
      </cdk-virtual-scroll-viewport>
      @if (dropdownConfig().remoteFilter && selectedItemsFromCache().length) {
      <div class="site-selection-dropdown-section-divider p-r-8">
        <span class="site-selection-dropdown-section-divider-line"></span>
      </div>
      <div class="site-selection-dropdown-option remote-filter-option-selected notranslate">
        <ng-container *ngTemplateOutlet="singleSelectOptionTpl; context: { item: selectedItemsFromCache()[selectedItemsFromCache().length - 1] }"></ng-container>
      </div>
      }
      }
    </div>
  </ng-template>

  <!-- Row content templates: Single select -->
  <ng-template #singleSelectOptionTpl let-item="item">
    <div class="site-selection-dropdown-option-wrapper"
      [class.site-selection-dropdown-option-wrapper-disabled]="isItemDisabled(item)">
      <span class="site-selection-dropdown-option-primary medium-text notranslate"
        [class.no-truncate]="viewMode() === 'group'" matTooltip=""
        matTooltipPosition="above" [matTooltipClass]="'app-mat-tooltip-text'" [matTooltipDisabled]="viewMode() === 'group'" showTooltipOnOverflow [tooltipDelayMs]="300">{{ getPrimaryLabel(item) }}</span>
      @if (viewMode() !== 'group') {
      <span class="site-selection-dropdown-option-secondary notranslate small-text" matTooltip=""
        matTooltipPosition="above" [matTooltipClass]="'app-mat-tooltip-text'" showTooltipOnOverflow [tooltipDelayMs]="300">{{ getSecondaryLabel(item) }}</span>
      }
    </div>
  </ng-template>

  <!-- Row content templates: Multi select -->
  <ng-template #multiSelectSelectAllOptionTpl>
    <div class="site-selection-dropdown-option-wrapper site-selection-dropdown-option-wrapper-multi">
      <mat-checkbox class="app-checkbox" [checked]="allItemsSelected()" [indeterminate]="someItemsSelected()"
        tabindex="-1" disableRipple="true">
      </mat-checkbox>
      <div class="site-selection-dropdown-option-labels">
        <span class="site-selection-dropdown-option-primary medium-text notranslate">All Sites</span>
      </div>
    </div>
  </ng-template>

  <ng-template #multiSelectOptionTpl let-item="item">
    <div class="site-selection-dropdown-option-wrapper site-selection-dropdown-option-wrapper-multi"
      [ngClass]="{'site-selection-dropdown-option-wrapper-multi-group-view': viewMode() === 'group', 'site-selection-dropdown-option-wrapper-disabled': isItemSelectionBlocked(item)}">
      <mat-checkbox class="app-checkbox" [checked]="isItemSelected(rawValueOf(item))" [disabled]="isItemSelectionBlocked(item)"
        tabindex="-1" disableRipple="true">
      </mat-checkbox>
      <div class="site-selection-dropdown-option-labels">
        <span class="site-selection-dropdown-option-primary medium-text notranslate"
          [class.no-truncate]="viewMode() === 'group'" matTooltip=""
          matTooltipPosition="above" [matTooltipClass]="'app-mat-tooltip-text'" [matTooltipDisabled]="viewMode() === 'group'" showTooltipOnOverflow [tooltipDelayMs]="300">{{ getPrimaryLabel(item) }}</span>
        @if (viewMode() !== 'group') {
        <span class="site-selection-dropdown-option-secondary notranslate small-text" matTooltip=""
          matTooltipPosition="above" [matTooltipClass]="'app-mat-tooltip-text'" showTooltipOnOverflow [tooltipDelayMs]="300">{{ getSecondaryLabel(item) }}</span>
        }
      </div>
    </div>
  </ng-template>

  <!-- Sort menu -->
  <mat-menu #sortMenu="matMenu" class="site-selection-dropdown-sort-menu" (closed)="onSortMenuClosed()">
    <mat-radio-group [value]="sortMode()" (change)="setSortMode($event.value)">

      <button mat-menu-item type="button" class="app-menu-item">
        <mat-radio-button value="recent" class="app-radio app-radio--compact">
          {{ dropdownConfig().orgSelection ? 'Recently Created Orgs' : 'Recently Created Sites' }}
        </mat-radio-button>
      </button>

      <button mat-menu-item type="button" class="app-menu-item">
        <mat-radio-button value="asc" class="app-radio app-radio--compact">
          Ascending (A-Z)
        </mat-radio-button>
      </button>

      <button mat-menu-item type="button" class="app-menu-item">
        <mat-radio-button value="desc" class="app-radio app-radio--compact">
          Descending (Z-A)
        </mat-radio-button>
      </button>
    </mat-radio-group>
  </mat-menu>
</div>
